import { EnigmaTokens } from "@type/tokens";
import { TypographyTypes } from "./typography.types";

export const getTextColorFromToken = (type, token: EnigmaTokens, disabled) => {
    if (disabled) return token.color.text.textDisabled;
    switch (type) {
        case TypographyTypes.warning:
            return token.color.text.textCaution;
        case TypographyTypes.success:
            return token.color.text.textSuccess;
        case TypographyTypes.secondary:
            return token.color.text.textSecondary;
        case TypographyTypes.danger:
            return token.color.text.textDanger;
        default:
            return null;
    }
};
